

const komisyonCalculator = ({nakliyeFiyat, komisyonType, komisyonValue}) => {

    let result;


    if(komisyonType === 1){
        result = `${(parseInt(nakliyeFiyat) * parseInt(komisyonValue)) / 100} TL`
    }

    if(komisyonType === 2){
        result = `%${(parseInt(komisyonValue) / parseInt(nakliyeFiyat)) * 100}`
    }

  return (
    <div style={{fontWeight: "var(--font-weight-xl)", fontSize: "var(--font-size-sm)"}}>{(nakliyeFiyat && komisyonType && komisyonValue) && `(${result})`}</div>
  )
}

export default komisyonCalculator